import React, {useEffect, useState} from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import classnames from "classnames";
import Switch from "@mui/material/Switch";
import Button from "@mui/material/Button";
import {useMediaQuery} from "react-responsive";
import CustomCurrencyInput from "../../components/CustomCurrencyInput";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {useUserContext} from "../../contexts/UserContext";
import useDidMountEffect from "../../hooks/useDidMountEffect";
import useEnterEffect from "../../hooks/useEnterEffect";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import {useDefaultQuoteSettingsContext} from "../../contexts/DefaultQuoteSettingsContext";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Popover from "@mui/material/Popover";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";


const initialState = {
    id: null,
    name: '',
    state: 'ALL',
    amount: null,
    is_capped: false,
    is_taxed: true,
    is_tax_capped: false,
}

export const DefaultSettingsCreateFee = ({usState}) => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const [anchorEl, setAnchorEl] = React.useState(null);
    const { setSettingsStateWithUpdate, quoteSettings, updateQuoteSettingsResponse } = useDefaultQuoteSettingsContext()
    const getInitialState = (usState) => {
        return {
            ...initialState,
            state: usState
        }
    }
    const [customFeeState, setCustomFeeState] = useState(getInitialState(usState))

    const isFinanced = customFeeState?.is_capped
    const isLoading = false

    const hasCustomFee = () => {
        return Boolean(
            customFeeState &&
            customFeeState?.name.length &&
            customFeeState?.state.length &&
            customFeeState?.amount !== null
        )
    }

    const handleClick = (event) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const setNewFeeInSettings = () => {
        if (hasCustomFee()) {
            setSettingsStateWithUpdate({
                fees: [...quoteSettings.fees, customFeeState]
            }, true)
        }
    }

    useEffect(function updateStateOnUSStateChange(){
        setCustomFeeState({...customFeeState, state: usState})
    }, [usState])

    useEnterEffect(function updateQuoteSettingsStateOnEnter(){
        setNewFeeInSettings()
    }, [customFeeState])

    useEffect(function resetState(){
        if (updateQuoteSettingsResponse?.data?.data && !updateQuoteSettingsResponse.loading && !updateQuoteSettingsResponse.error) {
            setCustomFeeState(getInitialState(usState))
        }
    }, [updateQuoteSettingsResponse])

    return (
        <TableRow
            key={'DealPageCreateCustomFee'}
            sx={{
                '&:last-child td, &:last-child th': {border: 0},
                height: '10px',
                background: "#F1FAF5"
            }}
        >

            <TableCell
                className={'DealPageFee fee-name'}
                scope="row"
                size={'small'}
                width={'60%'}
                align="left"
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: "row",
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <input
                        className=""
                        type="text"
                        value={customFeeState.name}
                        placeholder={isTabletOrMobile ? "Custom" : "Custom Fee Name"}
                        onChange={(e) => setCustomFeeState({...customFeeState, name: e.target.value})}
                        style={{
                            width: isTabletOrMobile ? '75px' : 'auto'
                        }}
                    />

                    <Button
                        style={{
                            alignSelf: 'end'
                        }}
                        disabled={!hasCustomFee()}
                        onClick={setNewFeeInSettings}
                    >
                        Add <KeyboardReturnIcon/>
                    </Button>
                </div>
            </TableCell>
            {
                !isTabletOrMobile &&
                <React.Fragment>
                    <TableCell
                        className={'DealPageFee'}
                        align="right"
                        size={'small'}
                        width={'20%'}
                    >
                        <Switch
                            disabled={isLoading}
                            checked={customFeeState.is_taxed}
                            onChange={() => {
                                setCustomFeeState({...customFeeState, is_taxed: !customFeeState.is_taxed})
                            }}
                        />
                    </TableCell>
                    <TableCell
                        className={'DealPageFee'}
                        align="right"
                        size={'small'}
                        width={'20%'}
                    >
                        <Switch
                            disabled={isLoading}
                            checked={customFeeState.is_capped}
                            onChange={() => {
                                setCustomFeeState({
                                    ...customFeeState,
                                    is_capped: !customFeeState.is_capped,
                                    is_tax_capped: !customFeeState.is_capped,
                                })
                            }}
                        />
                    </TableCell>
                </React.Fragment>
            }
            <TableCell
                align="right"
                size={'small'}
                className={'DealPageFee'}
                width={'60%'}
            >
                <div
                    style={{
                        display: isTabletOrMobile ? 'flex' : '',
                        flexDirection: isTabletOrMobile ? "row" : '',
                        alignItems: isTabletOrMobile ? 'center' : '',
                        justifyContent: isTabletOrMobile ? 'end' : '',
                    }}
                >
                    <CustomCurrencyInput
                        onChange={(value) => setCustomFeeState({...customFeeState, amount: value})}
                        className={classnames('payment-row_value custom-fee-input', {
                            mobileBlue: isTabletOrMobile && isFinanced,
                            loading: isLoading
                        })}
                        prefix="$"
                        value={customFeeState.amount}
                        key={'CustomFee'}
                        allowNull={true}
                        disabled={isLoading}
                        InputProps={isTabletOrMobile ? {} : undefined}
                    />
                    {
                        isTabletOrMobile &&
                        <div>
                            <MoreVertIcon onClick={handleClick}/>
                            <Popover
                                onClick={(e) => e.stopPropagation()}
                                open={Boolean(anchorEl)}
                                anchorEl={anchorEl}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    horizontal: 'right',
                                    vertical: 'top'
                                }}
                            >
                                <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        padding: "5px 10px"
                                    }}
                                >
                                    <Typography>
                                        Taxable
                                    </Typography>
                                    <Switch
                                        disabled={isLoading}
                                        checked={customFeeState.is_taxed}
                                        onChange={() => {
                                            setCustomFeeState({...customFeeState, is_taxed: !customFeeState.is_taxed})
                                        }}
                                    />
                                </Stack>
                                <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        padding: "5px 10px"
                                    }}
                                >
                                    <Typography>
                                        Capped
                                    </Typography>
                                    <Switch
                                        disabled={isLoading}
                                        checked={customFeeState.is_capped}
                                        onChange={() => {
                                            setCustomFeeState({
                                                ...customFeeState,
                                                is_capped: !customFeeState.is_capped,
                                                is_tax_capped: !customFeeState.is_capped,
                                            })
                                        }}
                                    />
                                </Stack>
                            </Popover>
                        </div>
                    }
                </div>
            </TableCell>
        </TableRow>
)
}